import React from "react";

/**
 * SoverenX brand mark + wordmark (official logo).
 *
 *  variant:
 *    "full"     — inline row for headers/sidebars (default)
 *    "icon"     — square badge, no wordmark
 *    "stacked"  — larger, for auth screens / public portals
 */
const LOGO_SRC = "/soverenx-logo.jpg";  // shield + full wordmark, black background

export function BrandLogo({ variant = "full" }) {
  if (variant === "icon") {
    // Crop the shield part visually by object-fit: cover-left on a square container
    return (
      <div
        className="w-9 h-9 rounded-md overflow-hidden bg-black border border-blue-500/40 flex items-center justify-center"
        aria-label="SoverenX Systems"
      >
        <img
          src={LOGO_SRC}
          alt="SoverenX"
          className="h-full w-auto max-w-none object-cover object-left"
          style={{ transform: "scale(2.3)", transformOrigin: "left center" }}
        />
      </div>
    );
  }

  if (variant === "stacked") {
    return (
      <div className="flex items-center justify-center" aria-label="SoverenX Systems">
        <img
          src={LOGO_SRC}
          alt="SoverenX Systems"
          className="h-16 sm:h-20 w-auto object-contain rounded-md bg-black px-3 py-2"
        />
      </div>
    );
  }

  // "full" — sidebar/header row
  return (
    <div className="flex items-center" aria-label="SoverenX Systems">
      <img
        src={LOGO_SRC}
        alt="SoverenX Systems"
        className="h-9 w-auto object-contain rounded bg-black px-1.5"
      />
    </div>
  );
}
